import axios from 'axios';
import store from '../state/store';
import { requestInterceptor } from './interceptors/requestInterceptor';
import { successHandler, errorHandler } from './interceptors/responseInterceptor';

const axiosInstance = axios.create();
const sysa_api_host = process.env.VUE_APP_API_URL;

axiosInstance.defaults.baseURL = sysa_api_host;
axiosInstance.defaults.timeout = 1500000;
axiosInstance.interceptors.request.use(requestInterceptor);
axiosInstance.interceptors.response.use(successHandler, errorHandler);

const defaultHeader = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
};

const apiService = {
  get(endpoint = '', data = {}, headers = null) {
    let queryString = new URLSearchParams(data).toString();
    const cfg = this.getRequestConfig(headers);
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/${endpoint}${queryString ? '?' + queryString : ''}`, cfg)
        .then((res) => {
          if (res?.status == 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  post(endpoint, data = {}, headers = null) {
    const cfg = this.getRequestConfig(headers);
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(`/${endpoint}`, data, cfg)
        .then((res) => {
          if (res?.status == 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  put(endpoint, data = {}, headers = null) {
    const cfg = this.getRequestConfig(headers);
    return new Promise((resolve, reject) => {
      axiosInstance
        .put(`/${endpoint}`, data, cfg)
        .then((res) => {
          if (res?.status == 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  destroy(endpoint, headers = null) {
    const cfg = this.getRequestConfig(headers);
    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(`/${endpoint}`, cfg)
        .then((res) => {
          if (res?.status == 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getRequestConfig(headers = null) {
    return {
      headers: this.getHeaders(headers)
    };
  },
  getHeaders() {
    return {
      ...defaultHeader,
      ...apiService.getAuthorization()
    };
  },
  getAuthorization() {
    if (store.state.isAuthenticated) {
      return {
        Authorization: `Bearer ${store.state.session.accessToken}`
      };
    }
    return {};
  }
};

export default apiService;
